import React, { useState } from 'react';

import CLocalizedText from '../../components/CLocalizedText';
import CPageModule from '../../components/CPageModule';
import I18nButton from '../../components/I18nButton';
import XDButton from '../../components/buttons/XDButton';
import XDCheckbox from '../../components/forms/XDCheckbox';
import { updateState } from '../../helpers/helper';

interface Props {
  onAccept: () => void;
}

interface State {
  boxIsChecked: boolean;
}

export default function PFactsheetTerms(props: Props) {
  const [state, setState] = useState<State>({ boxIsChecked: false });

  const handleAgree = () => {
    props.onAccept();
  };

  return (
    <>
      <CPageModule style={{ paddingTop: 0, paddingBottom: 0 }} fullWidth>
        <div className="relative">
          <div>
            <CLocalizedText dictKey={'global.termsOfUse.text'} />
          </div>
          <div className="absolute top-0 -right-2">
            <I18nButton />
          </div>
        </div>
        <XDCheckbox
          checked={state.boxIsChecked}
          onChange={() => {
            updateState<State>({ boxIsChecked: !state.boxIsChecked }, state, setState);
          }}
        >
          <CLocalizedText dictKey={'globalTermsP12Checkbox'} />
        </XDCheckbox>
        <div className={'flex gap-4 justify-end'}>
          <XDButton
            disabled={!state.boxIsChecked}
            className={'flex-grow justify-center py-4 bg-teal hover:bg-teal hover:bg-opacity-90 text-white font-bold'}
            onClick={handleAgree}
          >
            <CLocalizedText dictKey={'globalTermsP13IAgree'} />
          </XDButton>
        </div>
      </CPageModule>
    </>
  );
}
